export interface SidebarState {
  opened: boolean;
}

export const initializeSidebarState = function() {
  return {
    opened: false,
  };
};
